
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.0002 5.1697C12.8128 4.98345 12.5594 4.87891 12.2952 4.87891C12.031 4.87891 11.7776 4.98345 11.5902 5.1697L8.00019 8.7097L4.46019 5.1697C4.27283 4.98345 4.01938 4.87891 3.75519 4.87891C3.49101 4.87891 3.23756 4.98345 3.05019 5.1697C2.95646 5.26266 2.88207 5.37326 2.8313 5.49512C2.78053 5.61698 2.75439 5.74769 2.75439 5.8797C2.75439 6.01171 2.78053 6.14242 2.8313 6.26428C2.88207 6.38613 2.95646 6.49674 3.05019 6.5897L7.29019 10.8297C7.38316 10.9234 7.49376 10.9978 7.61562 11.0486C7.73747 11.0994 7.86818 11.1255 8.00019 11.1255C8.1322 11.1255 8.26291 11.0994 8.38477 11.0486C8.50663 10.9978 8.61723 10.9234 8.71019 10.8297L13.0002 6.5897C13.0939 6.49674 13.1683 6.38613 13.2191 6.26428C13.2699 6.14242 13.296 6.01171 13.296 5.8797C13.296 5.74769 13.2699 5.61698 13.2191 5.49512C13.1683 5.37326 13.0939 5.26266 13.0002 5.1697Z","fill":"currentColor"}})])
          )
        }
      }
    